"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function resolverTopLeft(_a) {
    var trigger = _a.trigger, content = _a.content, viewport = _a.viewport;
    var left = trigger.leftUpAnchor.x;
    var top = trigger.leftUpAnchor.y;
    if (left + content.width <= viewport.width && top + content.height <= viewport.height) {
        return {
            left: left,
            top: top,
        };
    }
    return false;
}
exports.default = resolverTopLeft;
//# sourceMappingURL=resolverTopLeft.js.map